import svg from "./intermediate-material-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const IntermediateMaterialIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.grey[900],
);

export default IntermediateMaterialIcon;
